module.exports = __webpack_public_path__ + "static/media/item_5_34_comp.51be490d.png";